@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.rides

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.rides.ReorderRideRequestDto

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017]-[2026] Narbase Technologies
 * All Rights Reserved.
 * Created by khalid-elkhidir
 * On: 2026/04/14.
 */

object ReorderRideEndpoint : EndPoint<ReorderRideEndpoint.Request, ReorderRideEndpoint.Response>() {
    class Request(
        val request: ReorderRideRequestDto
    )

    class Response(
        val passengerRideDto: PassengerRideDto
    )
}